module.exports = __webpack_public_path__ + "images/common/user_register_recommendation_img_02_6b7ead65eeff7e1a8812e7392a5836fe.png";